import { BellIcon } from "../../shared/Icons";
import { themeAtom } from "../../shared/atoms";
import { NotificationM } from "../models/notifications.models";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

interface Props {
  notifications: NotificationM[];
  isOpen: boolean;
  onClick: () => void;
}

// Indicates if there are unssen notifications from the voyage assesment
const NotificationIcon: React.FC<Props> = ({ notifications, isOpen, onClick }) => {
  const theme = useAtomValue(themeAtom);

  const isArr = Array.isArray(notifications);
  const hasUnseenNotifications = isArr ? notifications?.some((noti) => noti.IS_READ !== true) : false;

  const iconClasses = twMerge(
    "relative cursor-pointer rounded-lg p-2",
    isOpen && theme.myVesselsTable.tailwind.linkText,
    theme.headerComponent.notifications.iconBackground,
    theme.headerComponent.notifications.iconShape,
  );

  return (
    <div className={iconClasses} role="button" onClick={onClick}>
      <BellIcon className="text-inherit" />
      {hasUnseenNotifications && !isOpen && (
        <span
          className="absolute right-[6px] top-0 h-[10px] w-[10px] rounded-full"
          style={{ backgroundColor: theme.headerComponent.inline.dotActive }}
        />
      )}
    </div>
  );
};

export default NotificationIcon;
